import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { PsfShareFeedQuery, PsfShareFeedQueryVariables } from './shareFeed.graphql';
import { PsfShareFeed } from './shareFeed.graphql';

export type ShareFeedItem = NonNullable<PsfShareFeedQuery['petition']>['feeds']['shareFeed'][0];
export async function getShareFeed(
	{ gql: { fetch }, errorReporter: { report } }: UtilityContext,
	slug: string,
): Promise<readonly ShareFeedItem[]> {
	try {
		const { data } = await fetch<PsfShareFeedQuery, PsfShareFeedQueryVariables>({
			query: PsfShareFeed,
			variables: {
				slugOrId: slug,
			},
			rejectOnError: true,
		});
		return data?.petition?.feeds.shareFeed || [];
	} catch (e) {
		void report({
			error: new Error('Unexpected error when fetching share feed', { cause: e }),
			params: {
				slug,
			},
		});
		return [];
	}
}
